import { render, staticRenderFns } from "./dropdown-button.vue?vue&type=template&id=4e937894"
import script from "./dropdown-button.vue?vue&type=script&lang=js"
export * from "./dropdown-button.vue?vue&type=script&lang=js"
import style0 from "./dropdown-button.vue?vue&type=style&index=0&id=4e937894&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports